import { Routes, Route } from "react-router-dom";
import ShipPlanningOverview from "view/shipPlanning/ShipPlanningOverview";

const index = () => {
	return (
		<Routes>
			<Route index element={<ShipPlanningOverview />} />
		</Routes>
	);
};

export default index;
